import React from 'react';
import { Spinner } from '@chakra-ui/core';
import { pxToRem } from '../../utils/dimensionConverter';

export const LoadingGuard = ({ isLoading, children }) => {
  return isLoading ? (
    <Spinner
      size="xl"
      speed="1s"
      emptyColor="#EFEEEF"
      thickness={pxToRem(4)}
      color="#93328E"
      d="flex"
      m="5rem auto"
    />
  ) : (
    children
  );
};
